/* unplugin-vue-components disabled */import _regeneratorRuntime from "/Users/Zhuanz/Desktop/source/iafme_web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/Zhuanz/Desktop/source/iafme_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  "class": "content"
};
var _hoisted_2 = ["innerHTML"];
import { learnApi } from '@/api/international/index';
export default /*@__PURE__*/_defineComponent({
  __name: 'International_4',
  setup: function setup(__props) {
    var learnModel = ref({
      context: ''
    });
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var response, _response$data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return learnApi(1);
          case 2:
            response = _context.sent;
            if (response.code === 200) {
              learnModel.value = (_response$data = response.data) !== null && _response$data !== void 0 ? _response$data : {
                context: ''
              };
            }
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        "class": "list",
        innerHTML: _unref(learnModel).context
      }, null, 8, _hoisted_2)]);
    };
  }
});